import React, { useContext } from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import {
  useDataModel, params, string, shape, bool
} from '@thd-nucleus/data-sources';
import classNames from 'classnames/bind';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import styles from './ProductSample.style.scss';

const cx = classNames.bind(styles);
export const ProductSample = ({
  itemId
}) => {
  const { channel } = useContext(ExperienceContext);
  const { data } = useDataModel('product', {
    variables: {
      itemId
    }
  });

  const { product } = data || {};
  const canonicalUrl = product?.identifiers?.canonicalUrl;
  const samplesAvailable = product?.info?.samplesAvailable;
  const target = channel === 'mobile' ? '_self' : '_blank';

  if (!samplesAvailable) return null;

  return (
    <a
      className={cx('product-samples')}
      href={canonicalUrl}
      target={target}
    >
      <div className={cx('product-samples__icon')}>
        <Image
          asset="more-options.svg"
          alt="more-options-icon"
          stretchy
          width={42}
          height={31}
        />
      </div>
      <span className={cx('product-samples__title')}>Samples Available</span>
    </a>
  );
};

ProductSample.displayName = 'ProductSample';

ProductSample.dataModel = {
  product: params({
    itemId: string().isRequired(),
  }).shape({
    itemId: string(),
    dataSources: string(),
    info: shape({
      samplesAvailable: bool()
    }),
    identifiers: shape({
      canonicalUrl: string(),
    }),
  }),
};

ProductSample.propTypes = {
  itemId: PropTypes.string.isRequired
};
